@if (comboBox) {
  <mat-form-field color="primary" class="wetter-symbol-combo-box"
    appearance="outline">
    <mat-label>{{ comboBox.caption }}</mat-label>
    <mat-select (keydown)="filterItems($event)" (focusout)="filterItems($event)" class="wetter-symbol-combo-box-select"
      [(ngModel)]="comboBox.selectedItem" [disabled]="layoutElementUtil.ReadonlyMode"
      (ngModelChange)="comboBox.selectedItem = $event; comboBox.selectedItem.selected = true">

      <!--Der mat-select-trigger setzt die "custom" Auswahl inklusive Icon -->
      @if (comboBox.selectedItem) {
        <mat-select-trigger>
          {{ comboBox.selectedItem.description }}
          @if (comboBox.selectedItem.iconUrl) {
            <img class="combobox-item-icon" width="28" height="28"
              src="data:image/png;base64,{{comboBox.selectedItem.iconUrl}}" alt="{{comboBox.selectedItem.description}}">
            }
            @if (!comboBox.selectedItem.iconUrl) {
              <mat-icon class="combobox-item-icon"
                [style]="'color:'+ comboBox.selectedItem.iconColor">{{ comboBox.selectedItem.iconName }}
              </mat-icon>
            }
          </mat-select-trigger>
        }
        <!-- Die eigentlichen Items wird hier gerendert -->
        @if (comboBoxItemsWithFilter$ | async; as comboBoxItems) {
          @for (item of comboBoxItems; track trackByFn($index, item)) {
            <mat-option
              [value]="item">
            {{ item.code }} - {{ item.description }}
            @if (item.iconUrl) {
              <img class="combobox-item-icon" width="28" height="28"
                [src]="'data:image/png;base64,'+item.iconUrl"
                alt="{{item.description}}">
            }
            @if (!item.iconUrl) {
              <mat-icon class="combobox-item-icon" [style]="'color:'+ item.iconColor"
                >{{ item.iconName }}
              </mat-icon>
            }
          </mat-option>
        }
      }
    </mat-select>
    <!-- Kopierfunktion -->
    @if (comboBox?.copyItem) {
      <span matSuffix>
        <button (click)="$event.stopPropagation();copy()" mat-icon-button
          class="copy-value-btn mat-elevation-z0"
          color="primary">
          <mat-icon>low_priority</mat-icon>
        </button>
      </span>
    }
    @if (!comboBox.selectedItem.selected) {
      <mat-hint class="hint-text">Bitte treffe eine Auswahl!</mat-hint>
    }

  </mat-form-field>
}
